import moment from "moment";
import { FC } from "react";
import { Badge } from "rizzui";
import { Pickup } from "../../../../type/entities/pickup-type";
import { pickupStatuses } from "../../../../utils/SelectorMapping";
import cn from "../../../../utils/classNames";

interface NearbyPickupsProps {
    pickupId: string;
    nearbyPickups: (Pickup & { distanceKm?: number })[];
    isOpen: boolean;
    onAssignPickup: (pickup: Pickup) => void;
}

const NearbyPickups: FC<NearbyPickupsProps> = ({ 
    pickupId, 
    nearbyPickups, 
    isOpen,
    onAssignPickup
}) => {
    const getStatusColor = (status: string) => {
        const statusObj = pickupStatuses.find(s => s.value === status);
        return statusObj?.color || '#6B7280';
    };

    const getStatusLabel = (status: string) => {
        const statusObj = pickupStatuses.find(s => s.value === status);
        return statusObj?.label || status;
    };

    const getStatusGradient = (status: string) => {
        const statusObj = pickupStatuses.find(s => s.value === status);
        return statusObj?.gradientBg || 'bg-white';
    };

    const handleAssignClick = (pickup: Pickup) => {
        onAssignPickup(pickup);
    };

    return (
        <div id={`nearby-${pickupId}`} className={cn("collapsible mt-3", isOpen && "open")}>
            <div className="space-y-2">
                {nearbyPickups.map((near) => (
                    <div key={near.id} className={cn("rounded-md border px-3 py-2", getStatusGradient(near.pickupStatus))}>
                        <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0">
                                <div className="text-sm font-medium text-gray-900 truncate">
                                    {near.headquarter?.name}{near.headquarter?.city ? ` — ${near.headquarter.city}` : ''}
                                </div>
                                <div className="text-xs text-gray-500">
                                    {(near.route?.name ?? 'Sin Ruta')}
                                    {' · '}
                                    {moment(near.pickupDate?.date).format('DD/MM/YYYY HH:mm')}
                                    {typeof near.distanceKm === 'number' ? ` · ${near.distanceKm} km` : ''}
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <Badge
                                    variant="flat"
                                    style={{ backgroundColor: `${getStatusColor(near.pickupStatus)}20`, color: getStatusColor(near.pickupStatus) }}
                                    className="text-xs"
                                >
                                    {getStatusLabel(near.pickupStatus)}
                                </Badge>
                                <button
                                    onClick={() => handleAssignClick(near)}
                                    className="inline-flex items-center justify-center px-2.5 py-1.5 text-xs rounded-md border bg-white hover:bg-gray-50 transition-colors"
                                >
                                    Ir
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default NearbyPickups;